var _objectSpread = require("/node_modules/@babel/runtime/helpers/objectSpread");

var _toConsumableArray = require("/node_modules/@babel/runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _taggedTemplateLiteral = require("/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  padding-top: 5px;\n  padding-bottom: 5px;\n  width: 100%;\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  font-family: 'MuseoSans';\n  font-weight: 500;\n  font-size: 3em;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  display: inherit;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  position: sticky;\n  top: 0;\n  align-self: flex-start;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  @media screen and (min-width: 750px) {\n    width: 50%;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n\n  max-width: 1400px;\n  width: 100%;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  justify-content: center;\n  display: flex;\n\n  &:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: -1;\n    right: 0;\n    background-color: ", ";\n    height: 320px;\n\n    @media (min-width: ", ") {\n      height: 400px;\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  min-width: 490px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  min-width: 340px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  max-width: 250px;\n  margin: 10px auto;\n  padding-top: 10px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('prop-types'), require('@rtm-ui/layout'), require('styled-components'), require('@rtm-ui/img'), require('@rtm-ui/a'), require('@rtm-ui/typography'), require('@rtm-ui/icon'), require('@rtm-ui/theme'), require('@rtm-ui/form'), require('@rtm-ui/button'), require('@rtm-ui/phoneback'), require('@rtm-ui/list'), require('@rtm-ui/accordion'), require('@rtm-ui/dynamic-svg')) : typeof define === 'function' && define.amd ? define(['exports', 'react', 'prop-types', '@rtm-ui/layout', 'styled-components', '@rtm-ui/img', '@rtm-ui/a', '@rtm-ui/typography', '@rtm-ui/icon', '@rtm-ui/theme', '@rtm-ui/form', '@rtm-ui/button', '@rtm-ui/phoneback', '@rtm-ui/list', '@rtm-ui/accordion', '@rtm-ui/dynamic-svg'], factory) : (global = global || self, factory(global.plan = {}, global.React, global.PropTypes, global.RtmUiLayout, global.styled, global.RtmUiImg, global.RtmUiA, global.RtmUiTypography, global.RtmUiIcon, global.RtmUiTheme, global.RtmUiForm, global.RtmUiButton, global.RtmUiPhoneback, global.RtmUiList, global.RtmUiAccordion, global.RtmUiDynamicSvg));
})(this, function (exports, React, PropTypes, layout, styled, img, a, typography, icon, theme, form, button, phoneback, list, accordion, dynamicSvg) {
  'use strict';

  React = React && Object.prototype.hasOwnProperty.call(React, 'default') ? React['default'] : React;
  PropTypes = PropTypes && Object.prototype.hasOwnProperty.call(PropTypes, 'default') ? PropTypes['default'] : PropTypes;
  styled = styled && Object.prototype.hasOwnProperty.call(styled, 'default') ? styled['default'] : styled;

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  var MerchantBox = styled.div(_templateObject());
  var SidebarWrapper = styled.div(_templateObject2());
  var QuoteSidebarWrapper = styled.div(_templateObject3());
  var StyledWrapper = styled(layout.Box)(_templateObject4(), function (props) {
    return props.theme.colors.grayscale.lightest;
  }, function (props) {
    return props.theme.grid.md;
  });
  var ContentWrapper = styled(layout.Box)(_templateObject5());
  var ImageContentWrapper = styled(layout.Box)(_templateObject6());
  var Sidebar = styled(layout.Box)(_templateObject7());
  var StyledAccordion = styled(layout.Box)(_templateObject8(), function (props) {
    return props.theme.colors.grayscale.lightest;
  });
  var Cta = styled(layout.Card)(_templateObject9());

  var Sidebar$1 = function Sidebar$1(props) {
    var children = props.children,
        rest = _objectWithoutProperties(props, ["children"]);

    return (
      /*#__PURE__*/
      React.createElement(Sidebar, _extends({
        mb: [2, 3]
      }, rest), props.children)
    );
  };

  Sidebar$1.propTypes = {
    children: PropTypes.node.isRequired
  };

  var Merchant = function Merchant(_ref) {
    var logoUrl = _ref.logoUrl,
        full_name = _ref.full_name;
    return logoUrl &&
    /*#__PURE__*/
    React.createElement(MerchantBox, null,
    /*#__PURE__*/
    React.createElement(img.Img, {
      src: logoUrl,
      alt: full_name
    }));
  };

  var ClickToCall = function ClickToCall(_ref2) {
    var header = _ref2.header,
        link = _ref2.link,
        footer = _ref2.footer,
        track = _ref2.track,
        rest = _objectWithoutProperties(_ref2, ["header", "link", "footer", "track"]);

    return (
      /*#__PURE__*/
      React.createElement(theme.Theme, {
        variant: "regular"
      },
      /*#__PURE__*/
      React.createElement(React.Fragment, null, header &&
      /*#__PURE__*/
      React.createElement(typography.Paragraph, {
        color: "secondary",
        align: "center",
        px: [2, 3],
        pt: 2,
        dangerousHTML: header
      }), link && link.length > 0 &&
      /*#__PURE__*/
      React.createElement(a.A, {
        track: track,
        href: "tel:".concat(link)
      },
      /*#__PURE__*/
      React.createElement(typography.Header, {
        py: [1],
        align: "center",
        tag: "h3"
      },
      /*#__PURE__*/
      React.createElement(icon.Icon, {
        glyph: "phone",
        fill: "primary",
        inline: true
      }), " ", link)), footer &&
      /*#__PURE__*/
      React.createElement(typography.Paragraph, {
        dangerousHTML: footer,
        color: "secondary",
        align: "center",
        pb: [2, 2],
        px: [2, 3]
      })))
    );
  };

  ClickToCall.propTypes = {
    header: PropTypes.string,
    footer: PropTypes.string,
    link: PropTypes.string.isRequired,
    track: PropTypes.string.isRequired
  };
  ClickToCall.defaultProps = {};

  var axios = require('axios');

  var phonebackButtons = [{
    text: 'Morning',
    value: '800'
  }, {
    text: 'Afternoon',
    value: '1200'
  }, {
    text: 'Evening',
    value: '1800'
  }];
  var QuoteValueText = styled(typography.Header)(_templateObject10());
  var QuoteFormWrapper = styled(layout.Box)(_templateObject11());
  var QuoteContentWrapper = styled(layout.Box)(_templateObject12());
  var ThanyouWrapper = styled(layout.Box)(_templateObject13());
  var ButtonWrapper = styled(layout.Box)(_templateObject14()); // Acts as a one-off 'useEffect' loads the potential age options on load.

  var generateAgeOptions = function generateAgeOptions() {
    // Ruby (Rails) equivalent code
    // def age_options(age_range)
    // [].tap do |ages|
    //   ages << ["#{age_range.first - 1} years old or younger", age_range.first - 1]
    //   ages.concat age_range.map { |i| ["#{i} years old", i] }
    //   ages << ["#{age_range.last  + 1} years old or older", age_range.last + 1]
    // end
    // Lower bound - Hardcode
    var ageValues = [{
      label: '70 years old or older',
      value: '70'
    }];

    for (var age = 69; age > 15; age -= 1) {
      ageValues.push({
        label: "".concat(age, " years old"),
        value: age.toString()
      });
    } // Upper bound - Hardcode


    ageValues.push({
      label: '15 years old or younger',
      value: '15'
    });
    return ageValues;
  };
  /**
   * Helper function that passes the correct development state.
   * @returns
   */
  // Acts as a one-off 'useEffect' loads the potential cover option amounts on load.


  var generateCoverAmount = function generateCoverAmount() {
    // JS Implementation of (Ruby Method - ERB file)( cover_list = (100_000..950_000).step(50_000).to_a + (1_000_000..2_000_000).step(100_000).to_a )
    var coverAmounts = [];

    for (var coverLimit = 100000; coverLimit < 1000000; coverLimit += 50000) {
      coverAmounts.push({
        label: "$".concat(coverLimit.toLocaleString()),
        value: coverLimit.toString()
      });
    }

    for (var _coverLimit = 1000000; _coverLimit < 2000001; _coverLimit += 100000) {
      coverAmounts.push({
        label: "$".concat(_coverLimit.toLocaleString()),
        value: _coverLimit.toString()
      });
    }

    return coverAmounts;
  };

  var GetQuote = function GetQuote(props) {
    var _React$useState = React.useState(null),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        quoteResult = _React$useState2[0],
        setQuoteResult = _React$useState2[1];

    var _React$useState3 = React.useState(1),
        _React$useState4 = _slicedToArray(_React$useState3, 2),
        quoteStep = _React$useState4[0],
        setQuoteStep = _React$useState4[1];

    var _React$useState5 = React.useState({}),
        _React$useState6 = _slicedToArray(_React$useState5, 2),
        quoteFieldsValues = _React$useState6[0],
        setQuoteFieldsValues = _React$useState6[1];

    var _React$useState7 = React.useState(false),
        _React$useState8 = _slicedToArray(_React$useState7, 2),
        submittingQuote = _React$useState8[0],
        setSubmittingQuote = _React$useState8[1];

    var _React$useState9 = React.useState(false),
        _React$useState10 = _slicedToArray(_React$useState9, 2),
        submittingPhoneback = _React$useState10[0],
        setSubmittingPhoneback = _React$useState10[1];

    var _React$useState11 = React.useState({
      formError: props.formError || null,
      fieldErrors: props.fieldErrors || {}
    }),
        _React$useState12 = _slicedToArray(_React$useState11, 2),
        serverErrors = _React$useState12[0],
        setServerErrors = _React$useState12[1];

    var calculatorFields = [{
      label: 'First name',
      // || stateField.label
      labelSuper: '*',
      name: 'first_name',
      type: 'text',
      initialValue: quoteFieldsValues.first_name,
      placeholder: 'First name',
      // || stateField.placeholder
      autoComplete: 'off',
      config: {
        validator: 'required'
      },
      className: 'inline-fields first'
    }, {
      label: 'Surname',
      // || stateField.label
      name: 'last_name',
      type: 'text',
      initialValue: quoteFieldsValues.last_name,
      placeholder: 'Surname',
      // || stateField.placeholder
      autoComplete: 'off',
      config: {},
      className: 'inline-fields'
    }, {
      label: 'Phone number',
      // || stateField.label
      labelSuper: '*',
      name: 'primary_contact_no',
      type: 'tel',
      initialValue: quoteFieldsValues.primary_contact_no,
      placeholder: 'Phone number',
      // || stateField.placeholder
      autoComplete: 'off',
      config: {
        validator: 'valueMatch',
        validatorArgs: ['^(([0][1-9][0-9]{8}))$', 'Must start with 0 and be 10 digits long']
      },
      className: 'inline-fields first'
    }, {
      label: 'Age',
      labelSuper: '*',
      config: {
        component: 'dropdownfield',
        scrollable: true,
        validator: 'lifeInsuranceAgeDropdown'
      },
      type: 'text',
      initialValue: quoteFieldsValues.age,
      name: 'age',
      inputMode: 'none',
      options: generateAgeOptions(),
      className: 'inline-fields'
    }, {
      label: 'Gender',
      labelSuper: '*',
      config: {
        validator: 'requiredRadio'
      },
      name: 'gender',
      type: 'radio',
      initialValue: quoteFieldsValues.gender,
      options: [{
        label: 'Male',
        value: 'M'
      }, {
        label: 'Female',
        value: 'F'
      }],
      className: 'inline-fields first'
    }, {
      label: 'Smoking status',
      labelSuper: '*',
      config: {
        validator: 'requiredRadio'
      },
      name: 'smoker',
      initialValue: quoteFieldsValues.smoker,
      type: 'radio',
      options: [{
        label: 'Non Smoker',
        value: 'false'
      }, {
        label: 'Smoker',
        value: 'true'
      }],
      className: 'inline-fields'
    }, {
      label: 'Amount of cover',
      labelSuper: '*',
      config: {
        component: 'dropdownfield',
        scrollable: true,
        validator: 'required'
      },
      type: 'text',
      name: 'cover_required',
      inputMode: 'none',
      initialValue: quoteFieldsValues.cover_required,
      options: generateCoverAmount()
    }];

    var submitHandler =
    /*#__PURE__*/
    function () {
      var _ref3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(values) {
        var data, config, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                setSubmittingQuote(true);
                setServerErrors({
                  formError: '',
                  fieldErrors: {}
                });
                data = {
                  campaign_id: props.campaignId,
                  life_insurance_lead_fragment: {},
                  lead: {}
                };
                values.forEach(function (field) {
                  if (field.name === 'smoker' || field.name === 'cover_required') {
                    data['life_insurance_lead_fragment'][field.name] = field.value;
                  } else {
                    data['lead'][field.name] = field.value;
                  }
                });
                config = {
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'X-Authorization': props.userApiAuthToken
                  }
                };
                _context.next = 8;
                return axios.post(props.link, data, config).then(function (response) {
                  //  Sample Response: {"standard":"38.61","obs":"32.82","savings":"69.50","lead_id":1367596}
                  setQuoteResult(response.data);
                  setQuoteStep(2);
                  setQuoteFieldsValues(form.getFormValues(values));
                  layout.scrollToElement(null, 'ctaSection');
                  return response;
                }).catch(function (error) {
                  throw new form.FormError({
                    formError: 'Unexpected problem, please contact support.',
                    fieldErrors: {} //sample

                  });
                });

              case 8:
                response = _context.sent;
                setSubmittingQuote(false);
                return _context.abrupt("return", response);

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](0);
                setSubmittingQuote(false);
                setServerErrors(_context.t0.object);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 13]]);
      }));

      return function submitHandler(_x) {
        return _ref3.apply(this, arguments);
      };
    }();

    var submitPhoneback =
    /*#__PURE__*/
    function () {
      var _ref5 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(_ref4) {
        var link, campaignId, userApiAuthToken, value, data, config;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                link = _ref4.link, campaignId = _ref4.campaignId, userApiAuthToken = _ref4.userApiAuthToken, value = _ref4.value;
                _context2.prev = 1;
                setSubmittingPhoneback(true);
                data = {
                  campaign_id: campaignId,
                  phoneback: {
                    preferred_time: value
                  }
                };
                config = {
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'X-Authorization': userApiAuthToken
                  }
                };
                _context2.next = 7;
                return axios.patch(link, data, config).then(function (response) {
                  setQuoteStep(3);
                  setSubmittingPhoneback(false);
                  layout.scrollToElement(null, 'ctaSection');
                  return response.data;
                }).catch(function (error) {
                  setSubmittingPhoneback(false);
                  throw new form.FormError({
                    formError: 'Unexpected problem, please contact support.',
                    fieldErrors: {} //sample

                  });
                });

              case 7:
                _context2.next = 13;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](1);
                setSubmittingPhoneback(false);
                setServerErrors(_context2.t0.object);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 9]]);
      }));

      return function submitPhoneback(_x2) {
        return _ref5.apply(this, arguments);
      };
    }();

    return (
      /*#__PURE__*/
      React.createElement(layout.Box, {
        py: 16,
        px: 30
      }, quoteStep === 1 &&
      /*#__PURE__*/
      React.createElement(QuoteFormWrapper, {
        "data-testid": "quoteStep1"
      }, props.calculatorProps.quoteHeader &&
      /*#__PURE__*/
      React.createElement(typography.Markdown, {
        raw: props.calculatorProps.quoteHeader
      }),
      /*#__PURE__*/
      React.createElement(form.Form, {
        id: "life-form",
        TURN_OFF_AUTOCOMPLETE: true,
        onSubmit: submitHandler,
        fields: calculatorFields,
        renderFooter: function renderFooter(_ref6) {
          var FormError = _ref6.FormError;
          return (
            /*#__PURE__*/
            React.createElement(React.Fragment, null, FormError &&
            /*#__PURE__*/
            React.createElement(layout.Box, {
              pt: 2
            },
            /*#__PURE__*/
            React.createElement(typography.Small, {
              align: "left",
              color: "error"
            },
            /*#__PURE__*/
            React.createElement(Icon, {
              fill: "error",
              glyph: "error",
              size: 15
            }), FormError)),
            /*#__PURE__*/
            React.createElement(button.Button, {
              appearDisabled: submittingQuote,
              disabled: submittingQuote,
              block: true,
              track: "get_quote",
              width: "100%",
              type: "submit"
            }, props.calculatorProps.formSubmitButtonText),
            /*#__PURE__*/
            React.createElement(layout.Box, {
              style: {
                height: '15px',
                display: 'flex',
                alignSelf: 'flex-end'
              }
            },
            /*#__PURE__*/
            React.createElement(typography.Small, {
              align: "left",
              color: "error"
            }, serverErrors.formError)), props.calculatorProps.getQuoteDisclaimerText &&
            /*#__PURE__*/
            React.createElement(layout.Box, null,
            /*#__PURE__*/
            React.createElement(typography.Small, null,
            /*#__PURE__*/
            React.createElement(typography.Markdown, {
              scale: 0.75,
              py: 2,
              raw: props.calculatorProps.getQuoteDisclaimerText
            }))))
          );
        }
      })), quoteStep === 2 &&
      /*#__PURE__*/
      React.createElement(QuoteContentWrapper, {
        "data-testid": "quoteStep2"
      },
      /*#__PURE__*/
      React.createElement(ButtonWrapper, null,
      /*#__PURE__*/
      React.createElement(typography.Markdown, {
        py: 3,
        raw: props.calculatorProps.quoteResultHeaderText
      }),
      /*#__PURE__*/
      React.createElement(QuoteValueText, null, "$", quoteResult.obs),
      /*#__PURE__*/
      React.createElement(typography.Markdown, {
        raw: props.calculatorProps.paymentCycleText
      }),
      /*#__PURE__*/
      React.createElement(typography.Markdown, {
        pt: 4,
        pb: 3,
        raw: props.calculatorProps.timeToCallBackText
      }), phonebackButtons.map(function (button$1, index) {
        return (
          /*#__PURE__*/
          React.createElement(ButtonWrapper, {
            key: index
          },
          /*#__PURE__*/
          React.createElement(button.Button, {
            block: true,
            py: 3,
            track: "call_me_back",
            key: index,
            disabled: submittingPhoneback,
            appearDisabled: submittingPhoneback,
            onClick: function onClick() {
              submitPhoneback({
                link: props.calculatorProps.callbackUrl,
                campaignId: props.campaignId,
                value: button$1.value,
                userApiAuthToken: props.userApiAuthToken
              });
            }
          }, button$1.text))
        );
      }),
      /*#__PURE__*/
      React.createElement(layout.Box, {
        style: {
          height: '15px',
          display: 'flex',
          alignSelf: 'flex-end'
        }
      },
      /*#__PURE__*/
      React.createElement(typography.Small, {
        align: "left",
        color: "error"
      }, serverErrors.formError))), props.calculatorProps.phoneNumber &&
      /*#__PURE__*/
      React.createElement(layout.Box, {
        py: 2
      },
      /*#__PURE__*/
      React.createElement(typography.Markdown, {
        py: 2,
        raw: props.calculatorProps.phoneNumber
      })), props.calculatorProps.newQuoteText &&
      /*#__PURE__*/
      React.createElement(typography.Markdown, {
        raw: props.calculatorProps.newQuoteText,
        onClick: function onClick() {
          setQuoteResult(0);
          setQuoteStep(1);
        }
      })), quoteStep === 3 &&
      /*#__PURE__*/
      React.createElement(ThanyouWrapper, {
        "data-testid": "quoteStep3"
      },
      /*#__PURE__*/
      React.createElement(typography.Markdown, {
        py: 2,
        raw: props.calculatorProps.thankyouBody
      })))
    );
  };

  GetQuote.propTypes = {
    onSuccess: PropTypes.func,
    formInput: PropTypes.shape({})
  };

  var axios$1 = require('axios');

  var _onSubmit =
  /*#__PURE__*/
  function () {
    var _ref7 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3(values, authenticityToken, url, campaignId) {
      var data, config;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              data = {
                phoneback: {
                  campaign_id: campaignId
                }
              };
              values.forEach(function (field) {
                if (field.name === 'agreement_checkbox') {
                  data[field.name] = field.value;
                } else {
                  data['phoneback'][field.name] = field.value;
                }
              });
              config = {
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  'X-CSRF-Token': authenticityToken
                }
              };
              _context3.next = 5;
              return axios$1.post(url, data, config).catch(function (error) {
                throw new form.FormError({
                  formError: 'Unexpected problem, please contact support.',
                  fieldErrors: {}
                });
              });

            case 5:
              return _context3.abrupt("return", values);

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function onSubmit(_x3, _x4, _x5, _x6) {
      return _ref7.apply(this, arguments);
    };
  }();

  var Agreement = function Agreement(_ref8) {
    var disclaimer = _ref8.disclaimer;
    return (
      /*#__PURE__*/
      React.createElement(typography.Markdown, {
        scale: 0.7,
        raw: disclaimer
      })
    );
  };

  var RequestCallback = function RequestCallback(props) {
    var _React$useState13 = React.useState(false),
        _React$useState14 = _slicedToArray(_React$useState13, 2),
        isSubmitting = _React$useState14[0],
        setSubmitting = _React$useState14[1];

    var isSubmitted = props.isSubmitted,
        _onSuccess = props.onSuccess,
        formInput = props.formInput,
        rest = _objectWithoutProperties(props, ["isSubmitted", "onSuccess", "formInput"]);

    var form = formInput.form;
    var cbAgreement = {
      label: '',
      name: 'agreement_checkbox',
      type: 'checkbox',
      config: {
        validator: 'requiredRadio'
      },
      options: [{
        label:
        /*#__PURE__*/
        React.createElement(Agreement, {
          disclaimer: rest.disclaimer
        }),
        value: 'yes'
      }]
    };
    var formFields = rest.enableCheckbox ? [].concat(_toConsumableArray(form.fields), [cbAgreement]) : form.fields;
    var formWithHandler = {
      id: 'callback',
      fields: _toConsumableArray(formFields),
      onSubmit: function () {
        var _onSubmit2 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee4(values) {
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  setSubmitting(true);
                  return _context4.abrupt("return", _onSubmit(values, rest.authenticityToken, rest.link, rest.campaignId));

                case 2:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        function onSubmit(_x7) {
          return _onSubmit2.apply(this, arguments);
        }

        return onSubmit;
      }(),
      onSuccess: function () {
        var _onSuccess2 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee5(values) {
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _onSuccess();

                  return _context5.abrupt("return", values);

                case 2:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        function onSuccess(_x8) {
          return _onSuccess2.apply(this, arguments);
        }

        return onSuccess;
      }()
    };
    return (
      /*#__PURE__*/
      React.createElement(phoneback.Phoneback, _extends({}, rest, {
        form: formWithHandler,
        isPhonebacked: isSubmitted,
        isFormSubmitting: isSubmitting,
        renderTrigger: props.renderTrigger
      }))
    );
  };

  RequestCallback.propTypes = {
    onSuccess: PropTypes.func,
    isPhonebacked: PropTypes.bool,
    action: PropTypes.shape({}),
    formInput: PropTypes.shape({})
  };
  RequestCallback.defaultProps = {
    formInput: {
      form: {
        fields: [{
          label: 'First Name:',
          name: 'first_name',
          type: 'text',
          config: {
            validator: 'required'
          }
        }, {
          label: 'Last Name:',
          name: 'last_name',
          type: 'text',
          config: {
            validator: 'required'
          }
        }, {
          label: 'Phone Number:',
          hint: 'Enter 10 digit phone number without spaces',
          name: 'phone',
          type: 'tel',
          config: {
            mask: 'phoneAU',
            validator: 'mask',
            validatorArgs: ['phoneAU', 'Phone Number']
          }
        }]
      }
    }
  };

  var PrimaryAction = function PrimaryAction(props) {
    if (props.track === 'request_call_back') {
      return (
        /*#__PURE__*/
        React.createElement(RequestCallback, _extends({}, props, {
          isSubmitted: props.isPhonebackSubmitted,
          onSuccess: function onSuccess() {
            return props.setPhonebackSubmitted(true);
          },
          renderTrigger: typeof props.renderTrigger === 'function' ? function (open) {
            return props.renderTrigger({
              onClick: open
            });
          } : function (open) {
            return (
              /*#__PURE__*/
              React.createElement(button.Button, {
                track: props.track,
                onClick: open
              }, props.cta)
            );
          }
        }))
      );
    } else if (typeof props.renderTrigger === 'function' && props.track === 'quote_tool') {
      return props.renderTrigger({
        track: props.track,
        onClick: function onClick(e) {
          layout.scrollToElement(e, 'ctaSection');
        }
      });
    } else if (typeof props.renderTrigger === 'function') {
      return props.renderTrigger({
        track: props.track,
        as: 'a',
        href: props.link
      });
    } else if (props.track === 'quote_tool') {
      return (
        /*#__PURE__*/
        React.createElement(React.Fragment, null,
        /*#__PURE__*/
        React.createElement(layout.Block, {
          hideAt: "md"
        },
        /*#__PURE__*/
        React.createElement(button.Button, {
          track: props.track,
          as: "a",
          onClick: function onClick(e) {
            layout.scrollToElement(e, 'ctaSection');
          }
        }, props.cta)))
      );
    } else {
      return (
        /*#__PURE__*/
        React.createElement(button.Button, {
          track: props.track,
          as: "a",
          href: props.link
        }, props.cta)
      );
    }
  };

  var Cta$1 = function Cta$1(_ref9) {
    var actions = _ref9.actions,
        primaryActionProps = _ref9.primaryActionProps,
        merchant = _ref9.merchant,
        userApiAuthToken = _ref9.userApiAuthToken,
        calculatorProps = _ref9.calculatorProps;
    var callAction = actions.find(function (_ref10) {
      var track = _ref10.track;
      return track === 'click_to_call';
    });
    var getQuoteAction = actions.find(function (_ref11) {
      var track = _ref11.track;
      return track === 'quote_tool';
    });
    return (
      /*#__PURE__*/
      React.createElement(Cta, {
        my: 2,
        pt: '6px'
      },
      /*#__PURE__*/
      React.createElement(Merchant, merchant),
      /*#__PURE__*/
      React.createElement("div", {
        "scroll-target": "ctaSection"
      }, callAction &&
      /*#__PURE__*/
      React.createElement(ClickToCall, callAction), getQuoteAction &&
      /*#__PURE__*/
      React.createElement(GetQuote, _extends({
        userApiAuthToken: userApiAuthToken,
        calculatorProps: calculatorProps,
        campaignId: primaryActionProps.campaignId
      }, getQuoteAction)), !getQuoteAction &&
      /*#__PURE__*/
      React.createElement(layout.Box, {
        p: [2, 3],
        width: 1
      },
      /*#__PURE__*/
      React.createElement(PrimaryAction, primaryActionProps))))
    );
  };

  Cta$1.propTypes = {
    children: PropTypes.node
  };

  var Share = function Share(props) {
    return (
      /*#__PURE__*/
      React.createElement(layout.Box, {
        style: {
          display: 'flex'
        }
      },
      /*#__PURE__*/
      React.createElement(typography.Paragraph, null, props.message, ' ',
      /*#__PURE__*/
      React.createElement(a.A, {
        href: encodeURI("http://www.facebook.com/sharer/sharer.php?u=".concat(window.location)),
        track: "share_facebook",
        "data-testid": "share_facebook",
        asWrapper: true
      },
      /*#__PURE__*/
      React.createElement(icon.Icon, {
        inline: true,
        fill: "facebook",
        glyph: "facebook"
      })),
      /*#__PURE__*/
      React.createElement(a.A, {
        href: encodeURI("https://twitter.com/share?url=".concat(window.location)),
        track: "share_twitter",
        "data-testid": "share_twitter",
        asWrapper: true
      },
      /*#__PURE__*/
      React.createElement(icon.Icon, {
        inline: true,
        fill: "twitter",
        glyph: "twitter"
      }))))
    );
  };

  Share.propTypes = {
    message: PropTypes.string
  };
  Share.defaultProps = {
    message: 'Pass this special offer on to your friends'
  };
  var PlanReferenceContext =
  /*#__PURE__*/
  React.createContext();

  var MarkdownWrapper = function MarkdownWrapper(_ref12) {
    var content = _ref12.content,
        isEnabledMarkdown = _ref12.isEnabledMarkdown,
        rest = _objectWithoutProperties(_ref12, ["content", "isEnabledMarkdown"]);

    var referenceObject = React.useContext(PlanReferenceContext);
    return (
      /*#__PURE__*/
      React.createElement(React.Fragment, null, isEnabledMarkdown === false ?
      /*#__PURE__*/
      React.createElement(typography.Paragraph, {
        dangerousHTML: content
      }) :
      /*#__PURE__*/
      React.createElement(typography.Markdown, _extends({}, rest, {
        referenceObject: referenceObject,
        raw: content
      })))
    );
  };

  var PlanImg = function PlanImg(_ref13) {
    var src = _ref13.src,
        alt = _ref13.alt;
    var referenceObject = React.useContext(PlanReferenceContext);

    if (src.endsWith('.svg')) {
      return (
        /*#__PURE__*/
        React.createElement(dynamicSvg.DynamicSvg, {
          src: src,
          referenceObject: referenceObject
        })
      );
    } else {
      return (
        /*#__PURE__*/
        React.createElement(img.Img, {
          src: src,
          alt: alt
        })
      );
    }
  };

  var Main = function Main(props) {
    var refer = React.useContext(PlanReferenceContext);
    return (
      /*#__PURE__*/
      React.createElement(React.Fragment, null,
      /*#__PURE__*/
      React.createElement(layout.Box, {
        width: 1,
        py: 20
      },
      /*#__PURE__*/
      React.createElement(list.List, null, props.plan_features && props.plan_features.map(function (_ref14) {
        var icon = _ref14.icon,
            body = _ref14.body;
        return {
          icon: icon,
          fill: 'primary',
          body:
          /*#__PURE__*/
          React.createElement(typography.Markdown, {
            referenceObject: refer,
            raw: body
          })
        };
      }))))
    );
  };

  var Summary = function Summary(props) {
    var backAction = props.actions.find(function (_ref15) {
      var actionType = _ref15.actionType;
      return actionType === 'back';
    });
    var refer = React.useContext(PlanReferenceContext);
    var urlsArray = props.multi_image_file_urls || [];
    var imageDataArr = urlsArray.filter(function (str) {
      return str !== null;
    });
    return (
      /*#__PURE__*/
      React.createElement(layout.Box, {
        p: [0, 0, 0, 2]
      },
      /*#__PURE__*/
      React.createElement(layout.Box, {
        px: [2, 2, 3, 0],
        py: 3
      },
      /*#__PURE__*/
      React.createElement(typography.Header, {
        color: "primary",
        tag: "h1",
        pb: [2, 3]
      }, props.main_header_text)),
      /*#__PURE__*/
      React.createElement(layout.Block, {
        showAt: "md"
      }, imageDataArr.length == 2 ?
      /*#__PURE__*/
      React.createElement(ContentWrapper, null, imageDataArr.map(function (data) {
        return (
          /*#__PURE__*/
          React.createElement(ImageContentWrapper, null,
          /*#__PURE__*/
          React.createElement(PrimaryAction, _extends({}, props.primaryActionProps, {
            renderTrigger: function renderTrigger(triggerProps) {
              return (
                /*#__PURE__*/
                React.createElement(a.A, triggerProps,
                /*#__PURE__*/
                React.createElement(PlanImg, {
                  src: data,
                  alt: props.main_header_text
                }))
              );
            }
          })))
        );
      })) :
      /*#__PURE__*/
      React.createElement(PrimaryAction, _extends({}, props.primaryActionProps, {
        renderTrigger: function renderTrigger(triggerProps) {
          return (
            /*#__PURE__*/
            React.createElement(a.A, triggerProps,
            /*#__PURE__*/
            React.createElement(PlanImg, {
              src: props.main_image_file_url,
              alt: props.main_header_text
            }))
          );
        }
      }))),
      /*#__PURE__*/
      React.createElement(layout.Block, {
        hideAt: "md"
      }, imageDataArr.length == 2 ? //The current requirement is only to display 2 graphics in multigraphic feature. If backend is sending more than 2 image data, fall back to main image
      imageDataArr.map(function (data) {
        return (
          /*#__PURE__*/
          React.createElement(ImageContentWrapper, null,
          /*#__PURE__*/
          React.createElement(PrimaryAction, _extends({}, props.primaryActionProps, {
            renderTrigger: function renderTrigger(triggerProps) {
              return (
                /*#__PURE__*/
                React.createElement(a.A, triggerProps,
                /*#__PURE__*/
                React.createElement(PlanImg, {
                  src: data,
                  alt: props.main_header_text
                }))
              );
            }
          })))
        );
      }) :
      /*#__PURE__*/
      React.createElement(PrimaryAction, _extends({}, props.primaryActionProps, {
        renderTrigger: function renderTrigger(triggerProps) {
          return (
            /*#__PURE__*/
            React.createElement(a.A, triggerProps,
            /*#__PURE__*/
            React.createElement(PlanImg, {
              src: props.mobile_image_file_url,
              alt: props.main_header_text
            }))
          );
        }
      }))),
      /*#__PURE__*/
      React.createElement(layout.Box, {
        px: [2, 2, 3, 0],
        py: [20]
      }, !props.sub_header_text && props.sub_header_text.length > 0 &&
      /*#__PURE__*/
      React.createElement(layout.Box, {
        width: 1
      },
      /*#__PURE__*/
      React.createElement(layout.Box, {
        width: 1,
        py: 3
      },
      /*#__PURE__*/
      React.createElement(typography.Header, {
        weight: "normal",
        tag: "h3"
      }, props.sub_header_text))),
      /*#__PURE__*/
      React.createElement(layout.Box, {
        style: {
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between'
        }
      }, backAction ?
      /*#__PURE__*/
      React.createElement(button.Button, {
        as: "a",
        href: backAction.link,
        onClick: backAction.onClick,
        secondary: true
      }, backAction.cta) :
      /*#__PURE__*/
      React.createElement("div", null),
      /*#__PURE__*/
      React.createElement(PrimaryAction, props.primaryActionProps)),
      /*#__PURE__*/
      React.createElement(layout.Box, {
        style: {
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center'
        }
      },
      /*#__PURE__*/
      React.createElement(layout.Box, {
        width: [1, 1, 0.6, 1],
        pr: [0, 2, 2]
      },
      /*#__PURE__*/
      React.createElement(Main, props), props.tweet_text &&
      /*#__PURE__*/
      React.createElement(layout.Box, {
        pb: 2
      },
      /*#__PURE__*/
      React.createElement(Share, {
        message: props.tweet_text
      }))),
      /*#__PURE__*/
      React.createElement(layout.Box, {
        width: [1, 1, 0.4, 1]
      }, props.children)),
      /*#__PURE__*/
      React.createElement(layout.Box, {
        py: 20
      },
      /*#__PURE__*/
      React.createElement(theme.Theme, {
        variant: "b"
      },
      /*#__PURE__*/
      React.createElement(accordion.Accordion, {
        items: props.accordion,
        renderItem: function renderItem(item) {
          return (
            /*#__PURE__*/
            React.createElement(theme.Theme, {
              variant: "a"
            },
            /*#__PURE__*/
            React.createElement(StyledAccordion, {
              p: [2, 2, 3]
            },
            /*#__PURE__*/
            React.createElement(MarkdownWrapper, {
              content: item.content,
              isEnabledMarkdown: props.isEnabledMarkdown
            })))
          );
        },
        renderHeader: function renderHeader(item) {
          return (
            /*#__PURE__*/
            React.createElement(typography.Header, {
              tag: "h5"
            }, item.name)
          );
        }
      }))),
      /*#__PURE__*/
      React.createElement(layout.Box, {
        py: 2
      }, props.disclaimers && props.disclaimers.map(function (disclaimer, i) {
        return (
          /*#__PURE__*/
          // since fonts are em, this will result in the new
          // base being 12px and the <Small> tag will
          // handle applying base colors to text blocks
          React.createElement(typography.Small, {
            key: i
          },
          /*#__PURE__*/
          React.createElement(typography.Markdown, {
            pb: 10,
            scale: 0.75,
            referenceObject: refer,
            raw: disclaimer.body
          }))
        );
      }),
      /*#__PURE__*/
      React.createElement(typography.Small, {
        dangerousHTML: props.disclaimer_html
      }))))
    );
  };

  Summary.defaultProps = {
    isEnabledMarkdown: true
  };
  Main.propTypes = {
    plan_features: PropTypes.arrayOf(PropTypes.shape({
      body: PropTypes.string
    }))
  };
  Summary.propTypes = {
    authenticityToken: PropTypes.string,
    campaignId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    main_header_text: PropTypes.string,
    main_image_file_url: PropTypes.string,
    mobile_image_file_url: PropTypes.string,
    multi_image_file_urls: PropTypes.arrayOf(PropTypes.string),
    sub_header_text: PropTypes.string,
    merchant: PropTypes.shape({
      name: PropTypes.string,
      logo_url: PropTypes.string
    }),
    actions: PropTypes.arrayOf(PropTypes.shape({
      action: PropTypes.shape({
        track: PropTypes.string,
        link: PropTypes.string,
        cta: PropTypes.string
      })
    })),
    isEnabledMarkdown: PropTypes.bool,
    children: PropTypes.node,
    disclaimer_html: PropTypes.string,
    accordion: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string
    })),
    tweet_text: PropTypes.string
  };

  var PlanSidebar = function PlanSidebar(_ref16) {
    var children = _ref16.children,
        calculatorProps = _ref16.calculatorProps,
        props = _objectWithoutProperties(_ref16, ["children", "calculatorProps"]);

    return (
      /*#__PURE__*/
      React.createElement(layout.Block, {
        showAt: "lg",
        width: [1, 1, 1, 0.4]
      },
      /*#__PURE__*/
      React.createElement(Sidebar$1, _extends({
        flex: 0,
        px: [0, 0, 0, 3]
      }, props), calculatorProps &&
      /*#__PURE__*/
      React.createElement(QuoteSidebarWrapper, null, children), !calculatorProps &&
      /*#__PURE__*/
      React.createElement(SidebarWrapper, null, children)))
    );
  };

  var Plan = function Plan(_ref17) {
    var authenticityToken = _ref17.authenticityToken,
        plan = _ref17.plan,
        actions = _ref17.actions,
        reference = _ref17.reference,
        phonebackProps = _ref17.phonebackProps,
        isEnabledMarkdown = _ref17.isEnabledMarkdown,
        calculatorProps = _ref17.calculatorProps,
        rest = _objectWithoutProperties(_ref17, ["authenticityToken", "plan", "actions", "reference", "phonebackProps", "isEnabledMarkdown", "calculatorProps"]);

    var _React$useState15 = React.useState(plan.has_phoneback),
        _React$useState16 = _slicedToArray(_React$useState15, 2),
        isPhonebackSubmitted = _React$useState16[0],
        setPhonebackSubmitted = _React$useState16[1];

    var clickAction = actions.find(function (_ref18) {
      var track = _ref18.track;
      return track === 'get_started';
    });
    var callbackAction = actions.find(function (_ref19) {
      var track = _ref19.track;
      return track === 'request_call_back';
    });
    var getQuoteAction = actions.find(function (_ref20) {
      var track = _ref20.track;
      return track === 'quote_tool';
    });
    var primaryAction = callbackAction || getQuoteAction || clickAction;

    var primaryActionWithPhonebackProps = _objectSpread({}, primaryAction, phonebackProps, {
      authenticityToken: authenticityToken,
      campaignId: plan.campaign_id,
      isPhonebackSubmitted: isPhonebackSubmitted,
      setPhonebackSubmitted: setPhonebackSubmitted
    });

    return (
      /*#__PURE__*/
      React.createElement(PlanReferenceContext.Provider, {
        value: reference
      },
      /*#__PURE__*/
      React.createElement(StyledWrapper, null,
      /*#__PURE__*/
      React.createElement(ContentWrapper, {
        pt: [2, 2, 3],
        px: [0, 0, 0, 48]
      },
      /*#__PURE__*/
      React.createElement(layout.Box, {
        flex: 1,
        px: [0, 0, 0, 3],
        width: [1, 1, 1, 0.6]
      },
      /*#__PURE__*/
      React.createElement(Summary, _extends({}, plan, {
        campaignId: plan.campaign_id,
        actions: actions,
        primaryActionProps: primaryActionWithPhonebackProps,
        authenticityToken: authenticityToken,
        isEnabledMarkdown: isEnabledMarkdown
      }),
      /*#__PURE__*/
      React.createElement(layout.Block, {
        hideAt: "lg"
      },
      /*#__PURE__*/
      React.createElement(Cta$1, {
        actions: actions,
        primaryActionProps: primaryActionWithPhonebackProps,
        merchant: plan.merchant,
        calculatorProps: calculatorProps,
        userApiAuthToken: rest.userApiAuthToken
      })))),
      /*#__PURE__*/
      React.createElement(PlanSidebar, {
        calculatorProps: calculatorProps
      },
      /*#__PURE__*/
      React.createElement(layout.Block, {
        showAt: "lg"
      },
      /*#__PURE__*/
      React.createElement(Cta$1, {
        actions: actions,
        primaryActionProps: primaryActionWithPhonebackProps,
        merchant: plan.merchant,
        calculatorProps: calculatorProps,
        userApiAuthToken: rest.userApiAuthToken
      }))))))
    );
  };

  Plan.propTypes = {
    authenticityToken: PropTypes.string,
    entity: PropTypes.shape({
      name: PropTypes.string
    }),
    plan: PropTypes.shape({
      main_header_text: PropTypes.string,
      main_image_file_url: PropTypes.string,
      sub_header_text: PropTypes.string,
      disclaimer_html: PropTypes.string,
      multi_image_file_urls: PropTypes.arrayOf(PropTypes.string),
      plan_features: PropTypes.arrayOf(PropTypes.shape({
        icon: PropTypes.string,
        body: PropTypes.string
      }))
    }),
    productTips: PropTypes.arrayOf(PropTypes.shape({
      header: PropTypes.string,
      body: PropTypes.string
    })),
    switchFacts: PropTypes.arrayOf(PropTypes.shape({
      header: PropTypes.string,
      body: PropTypes.string
    })),
    isEnabledMarkdown: PropTypes.bool,
    user: PropTypes.shape({}),
    actions: PropTypes.arrayOf(PropTypes.shape({
      action: PropTypes.string
    })),
    testimonials: PropTypes.arrayOf(PropTypes.shape({
      selfie: PropTypes.string
    }))
  };
  PlanSidebar.propTypes = {
    children: PropTypes.node
  };
  exports.Plan = Plan;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});